import { t } from '@gem/modules/i18n';
import { logger } from '@gem/modules/logger';

import Tasks from 'APP/Tasks';
import Entities from 'STORE';

// Needs Bff implementation
export const setActiveStream = async (stream, groupId) => {
  try {
    const { initiatorId, channelId, status, totalViewers = 0, comment = '' } = stream;

    if (Entities.GroupsStore.getGroupById(groupId).withoutMe) {
      Tasks.app.showAlert(t('stream_alert_cant_join_without_subscription'));
      return;
    }

    if (Entities.Calls.ongoingCall || Entities.ActiveStream.hasStream) {
      Tasks.app.showAlert(t('calls_join_another_call'));
      return;
    }

    const response = {};

    Entities.ActiveStream.setStream({
      initiatorId,
      groupId,
      channelId,
      status,
      totalViewers,
      title: comment,
      ...response,
    });

    Entities.ActiveStream.stream.addInitiator();
    Entities.ActiveStream.stream.setActiveStreamer(response.initiatorUid);

    return Entities.ActiveStream.stream;
  } catch (e) {
    logger.get('API').error('streams.getStreamInfo', e);
    return null;
  }
};
